module.exports = {
	path: "/orders",
	component: require("@views/Proposals").default,
	meta: {
		showButton: true,
		title: "Orders",
		icon: ["far", "file-alt"],
		primary: true,
		// in_privacy: true,
		search: {
			placeholder: "Search Orders",
			show: true
		}
	}
};
